<template>
  <div>
    <div slot="header" class="header">
      <form-item>
        <span v-if="inappStyles">
          {{ $t('CampaignForm_InApp_InlinePreference_Title') }}
        </span>
        <checkbox
          :title="$t('CampaignForm_InApp_InlinePreference_Title')"
          v-model="value.enabled"
          v-if="!inappStyles"
          data-qa="inline-preference-center-checkbox"
        />
      </form-item>
    </div>
    <div class="body" v-if="value.enabled || inappStyles">
      <form-item>
        <checkbox title="" v-model="value.enabled" v-if="inappStyles" />
      </form-item>
      <form-item
        prop="subscription"
        :label="$t('CampaignForm_InApp_Field_Subscription')"
      >
        <enum-select
          :options="subscriptionLabels"
          v-model="value.subscription"
          data-qa="preference-subscription-dropdown"
        />
      </form-item>
      <template v-if="onSiteTerms">
        <form-item>
          <checkbox
            class="terms-checkbox"
            :title="
              $t('CampaignForm_Onsite_InlinePreferenceAgeConfirmation_Title')
            "
            v-model="value.age_confirmation_enabled"
            data-qa="age-confirmation-checkbox"
          />
        </form-item>
        <form-item
          prop="age_confirmation_text"
          v-if="value.age_confirmation_enabled"
        >
          <el-input
            v-model="value.age_confirmation_text"
            type="textarea"
            data-qa="age-confirmation-input"
          />
        </form-item>
        <form-item>
          <checkbox
            class="terms-checkbox"
            :title="$t('CampaignForm_Onsite_InlinePreferenceTerms_Title')"
            v-model="value.terms_enabled"
            data-qa="terms-and-conditions-checkbox"
          />
        </form-item>
        <form-item class="redactor" v-if="value.terms_enabled">
          <redactor
            v-model="value.terms_text"
            :plugins="['link']"
            :buttons="['link']"
            key="terms_text"
            :use-default-plugins="false"
            :use-default-buttons="false"
            :custom-config="{
              tabKey: false,
              enterKey: false,
              maxHeight: 50
            }"
            data-qa="terms-and-conditions-input"
          />
        </form-item>
      </template>
      <form-item
        prop="opt_in"
        :label="$t('CampaignForm_InApp_Field_Inline_OptIn_Title')"
      >
        <el-input
          v-model="value.opt_in"
          type="textarea"
          data-qa="preference-opt-in-input"
        />
      </form-item>
      <form-item v-if="onSiteTerms">
        <checkbox
          class="terms-checkbox"
          :title="$t('CampaignForm_Onsite_InlinePreferenceContactField_Title')"
          v-model="value.contact_field"
          data-qa="contact-field-checkbox"
        />
      </form-item>
      <form-item
        prop="opt_in"
        :label="$t('CampaignForm_InApp_Field_Inline_Button_Title')"
      >
        <el-input v-model="value.button" data-qa="preference-button-input" />
      </form-item>
    </div>
  </div>
</template>

<script>
import Checkbox from '@/common/components/form/Checkbox'
import FormItem from '@/common/components/form/FormItem'
import EnumSelect from '@/common/components/form/EnumSelect'
import Redactor from '@/common/components/Redactor'
import {
  subscriptionLabels,
  subscriptionTypes
} from '@/modules/campaign-manage/enum/InAppTypesEnum'
export default {
  name: 'InlinePreference',
  components: { EnumSelect, FormItem, Checkbox, Redactor },
  props: {
    value: {
      type: Object,
      required: true
    },
    inappStyles: {
      type: Boolean,
      default: false
    },
    onSiteTerms: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (this.value.button === null && this.value.enabled) {
      this.setOptInText()
    }
    if (!this.value.terms_text) {
      this.setTermsText()
    }
    if (!this.value.age_confirmation_text) {
      this.value.age_confirmation_text = this.$t(
        'CampaignForm_Onsite_InlinePreferenceAgeConfirmation_Default'
      )
    }
  },
  data() {
    return {
      subscriptionLabels
    }
  },
  methods: {
    setOptInText() {
      if (this.value.subscription === subscriptionTypes.EMAIL) {
        this.value.button = this.$t(
          'CampaignForm_InApp_Field_Inline_Button_Email'
        )
        this.value.opt_in = this.$t(
          'CampaignForm_InApp_Field_Inline_OptIn_Email'
        )
      } else {
        this.value.button = this.$t(
          'CampaignForm_InApp_Field_Inline_Button_SMS'
        )
        this.value.opt_in = this.$t('CampaignForm_InApp_Field_Inline_OptIn_SMS')
      }
    },
    setTermsText() {
      this.value.terms_text = this.$t(
        'CampaignForm_Onsite_InlinePreference_ApproveTerms'
      )
    }
  },
  watch: {
    'value.subscription': {
      handler() {
        this.setOptInText()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.creative {
  background-color: #f8fafc;
  border: 1px solid #dbdee7;
  margin: 10px;
  box-shadow: none;
  .header {
    border-bottom: none;
    .delete-btn {
      float: right;
      padding: 3px 0;
      cursor: pointer;
      font-size: 16px;
      color: #a7acba;
    }
    span {
      font-weight: 600;
      font-size: 14px;
    }
  }
}
/deep/ .el-card__header {
  padding: 16px;
  border-bottom: none;
}

/deep/ .terms-checkbox .el-checkbox__label {
  line-height: 30px;
}
/deep/ .el-form-item {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/setup/InlinePreference.vue